<template>
  <div class="columns">
      <div class="column is-8">
        <figure class="image">
          <img src="../assets/login.png" alt="box carrierr" />
        </figure>
    </div>
    <div class="column is-4 top-margin-10">
        <form @submit.prevent="login">
          <h3 class="company-title is-size-3 has-text-weight-semibold has-text-centered">Kerala Cotton Stores</h3>
          <b-field>
            <b-input
              placeholder="Phone Number"
              icon-pack="fas"
              icon="fas fa-mobile-alt"
              v-model="phoneNumber"
              required
            ></b-input>
          </b-field>
          <b-field >
            <b-input
              type="password"
              placeholder="Password"
              icon-pack="fas"
              icon="fas fa-key"
              password-reveal
              v-model="password"
              required
            ></b-input>
          </b-field>
          <b-button
            type="is-primary"
            icon-pack="fas"
            icon-right="fas fa-check-circle"
            expanded
            native-type="submit"
            :loading="isLoading"
          >Log In</b-button>
        </form>
        <!-- <br>
        <b-field>
          <div class="has-text-left">
            <a href="/#/reset">Forgot Password</a>
          </div>
        </b-field> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      phoneNumber: '',
      password: '',
      isLoading:false
    }
  },
  methods: {
    login() {
      if (this.phoneNumber && this.password) {
        this.isLoading = true
        this.$store
          .dispatch("login", {
            phone: this.phoneNumber,
            password: this.password
          })
          .then(response => {
            if (response.error == 0) {
              this.$router.push({name:'Dashboard'})
            }
            else{
               this.ToastError("Please check your credentials")
            }
          })
          .catch(() => {
            this.ToastError("Problem in login")
          })
          .finally(()=>{
            this.isLoading = false
          })
      }
    }
  },
  beforeCreate() {
    if (this.$store.state.isLoggedIn) {
      print('logged in')
    }
  }
}
</script>

<style>

.top-margin-10{
    margin-top:10%;
}

/* .company-title{
  font-family: "Nunito", sans-serif;
} */


</style>